import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ProgressSteps} from "../../elements.types";

@Component({
  selector: 'as-progress',
  templateUrl: './progress.component.html',
  styleUrls: ['./progress.component.scss']
})
export class ProgressComponent implements OnInit {

  @Input() eventBroadcaster;
  @Input() steps: Array<ProgressSteps>;
  @Output() currentStep = new EventEmitter();

  counterIndex: number = 0;
  previousIndex: number = 0;

  stepsProgression = {
    lastStep: true, firstStep: true, step: {}
  }

  // currentStep: infoStepType;

  current: ProgressSteps;

  constructor() {
  }

  ngOnInit() {
    this.current = this.steps[0];

    this.eventBroadcaster.subscribe((p) => {

      switch (p) {
        case "previous" :
          this.counterIndex--;
          break;
        case "next" :
          this.counterIndex++
      }

      this.current = this.steps[this.counterIndex];
      this.stepsProgression.step = this.current;

      this.previousIndex = this.counterIndex == 0 ? 0 : this.counterIndex - 1;

      if (this.counterIndex == (this.steps.length - 1)) {
        this.stepsProgression.firstStep = false;
        this.stepsProgression.lastStep = true;
      }

      if (this.counterIndex != 0 && this.counterIndex != (this.steps.length - 1)) {
        this.stepsProgression.firstStep = false;
        this.stepsProgression.lastStep = false;
      }

      if (this.counterIndex == 0) {
        this.stepsProgression.firstStep = true;
        this.stepsProgression.lastStep = false;
      }

      this.currentStep.emit(
        this.stepsProgression
      )

    })
  }

}
